import { createMutation, createTriggerResource } from '@magicdoorinc/ui';
import { createMagicDoorContext } from '~/contexts/utils';
import { invoiceCreditsRepository } from '~/repositories/invoiceCreditsRepository';
import type { GetInvoiceCreditsParams } from '~/repositories/invoiceCreditsRepository';
import type { BankAccountDto, ChartOfAccountDto, MagicDoorBillCreditItemDto } from '~/swagger/portal/Api';

export const [InvoiceCreditsProvider, useInvoiceCredits] = createMagicDoorContext('InvoiceCredits', () => {
  const [filtered, setFilter, actions] = createTriggerResource(async (filter?: GetInvoiceCreditsParams) => {
    const res = await invoiceCreditsRepository.getInvoiceCredits(filter);
    const items = res.items.map((item: MagicDoorBillCreditItemDto) => {
      return {
        ...item,
        bankAccountName: res.bankAccounts?.find((bankAccount: BankAccountDto) => bankAccount.id === item.bankAccountId)?.name,
        chartOfAccountName: res.chartOfAccounts?.find((chartOfAccount: ChartOfAccountDto) => chartOfAccount.id === item.chartOfAccountId)
          ?.name,
        memo: item.metadata?.memo || item.metadata?.description || '',
      };
    });

    return {
      ...res,
      items,
    };
  });

  const getInvoiceCredit = createMutation(async (creditId: string) => {
    return await invoiceCreditsRepository.getInvoiceCredit(creditId);
  });

  return {
    filtered,
    setFilter: (filter: GetInvoiceCreditsParams) => setFilter(filter),
    refetch: actions.refetch,
    getInvoiceCredit,
  };
});
